<app-blockly-list *ngIf="!verDetalle && !buscando" [formulasList]="formulasList" 
                                                   [permisoEdicion]="permisoEdicion"
                                                   (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-blockly-list>

<app-blockly-edit #ChildFormulaEdit *ngIf="verDetalle" [formulaActual]="formulaActual" 
                            [permisoEdicion]="permisoEdicion"
                            (VisualizarLista)="OnVisualizarLista()">
</app-blockly-edit>